export default "__VITE_ASSET__69a1feab__"